module.exports = __webpack_public_path__ + "static/img/impera_brigade_guard.69c1ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/impera_brigade_guard.png
// module id = eOpz
// module chunks = 0